import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={525}
        height={281}
        viewBox="0 0 525 281"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_8042_28185)">
            <path
                d="M145.2 130.02C145.2 151.52 127.8 168.92 106.4 168.92C85 168.92 67.5 151.52 67.5 130.02C67.5 108.52 84.9 91.2197 106.4 91.2197C127.9 91.2197 145.2 108.52 145.2 130.02Z"
                fill="url(#paint0_linear_8042_28185)"
            />
            <path
                d="M194.5 138.92C194.3 156.22 201 172.92 213.1 185.32C225.2 197.72 241.7 204.82 259 205.02C271 205.02 282.7 201.62 292.8 195.22V82.6203C282.7 76.2203 271 72.8203 259 72.8203C241.7 73.0203 225.2 80.1203 213.1 92.5203C201 104.92 194.3 121.62 194.5 138.92ZM282.6 104.32L283.7 105.12L279.9 116.92L278.1 115.62C273.2 112.32 267.5 110.62 261.6 110.52C254.1 110.52 248.9 114.82 248.9 120.92C248.9 127.02 252.6 130.32 261.5 134.02C272.5 138.42 282.7 144.32 282.7 157.22C282.7 162.42 280.8 167.42 277.5 171.32C274.1 175.22 269.5 177.92 264.4 178.72V191.62H253V179.62C247.7 179.42 242.6 177.92 238 175.32L236.7 174.52L241 162.92L242.8 164.02C247.1 166.72 252.1 168.12 257.2 168.02C265.4 168.02 268.3 163.22 268.3 159.22C268.3 155.22 265.1 151.22 254.3 146.72C240.3 140.82 234.4 133.62 234.4 122.22C234.4 116.82 236.3 111.62 239.7 107.52C243.3 103.22 248.3 100.22 253.8 99.1203V85.8203H265V98.5203C271.2 98.9203 277.3 100.92 282.6 104.32Z"
                fill="url(#paint1_linear_8042_28185)"
            />
            <path
                d="M157.399 1.12033C99.4988 -3.27967 48.9988 5.32034 7.29878 26.4203H6.89878C2.59878 28.6203 -0.101221 33.2203 -0.00122081 38.0203V262.12C-0.00122081 266.52 2.29878 270.72 6.09878 273.02C9.89878 275.32 14.5988 275.52 18.5988 273.52L19.7988 272.92C57.0988 254.02 102.699 246.72 155.599 250.42C198.299 253.82 240.799 260.12 282.699 269.22L292.799 271.12V243.42L287.999 242.42C244.999 233.12 201.499 226.72 157.599 223.22C147.799 222.42 138.199 222.12 128.899 222.12C105.299 222.02 81.7988 224.62 58.8988 230.02V229.42C58.8988 221.82 55.0988 214.82 48.7988 210.72C42.4988 206.52 34.4988 205.82 27.5988 208.82V76.3203C34.2988 79.2203 41.9988 78.7203 48.1988 74.9203C54.3988 71.1203 58.4988 64.6203 58.9988 57.3203C59.4988 50.0203 56.4988 42.9203 50.8988 38.3203C84.9988 28.4203 120.599 25.0203 155.899 28.2203C198.599 31.6203 241.099 37.9203 282.899 47.0203L292.999 48.9203V21.2203L288.199 20.2203C244.899 11.0203 201.299 4.62033 157.399 1.12033Z"
                fill="url(#paint2_linear_8042_28185)"
            />
            <path
                d="M334.8 256.12H331.4V231.92H309V275.72L318.6 277.02C326 278.12 333.7 278.92 341.5 279.52L352.7 280.52L354.5 258.22L343.3 257.22L334.8 256.12Z"
                fill="url(#paint3_linear_8042_28185)"
            />
            <path
                d="M442.002 254.22C428.302 256.02 414.102 257.22 399.802 257.82L388.602 258.22L389.502 280.62L400.702 280.42C415.702 279.82 430.502 278.62 445.002 276.62L456.102 275.12L453.202 252.92L442.002 254.22Z"
                fill="url(#paint4_linear_8042_28185)"
            />
            <path
                d="M502.301 241.52L497.101 243.12L486.301 246.22L492.601 267.72L503.401 264.62L508.101 263.22H508.701C513.401 261.82 517.601 258.82 520.501 254.82C523.401 250.82 525.001 246.02 524.901 241.02V206.62H502.301V241.52Z"
                fill="url(#paint5_linear_8042_28185)"
            />
            <path
                d="M400.702 51.7195C415.802 51.1195 430.602 49.7195 445.002 47.8195L456.102 46.2195L453.002 24.0195L441.902 25.6195C428.302 27.5195 414.102 28.7195 399.802 29.4195L388.602 29.8195L389.602 52.2195L400.702 51.7195Z"
                fill="url(#paint6_linear_8042_28185)"
            />
            <path
                d="M502.301 105.52H524.701V171.32H502.301V105.52Z"
                fill="url(#paint7_linear_8042_28185)"
            />
            <path
                d="M501.802 12.8201C500.602 12.7201 499.402 12.7201 498.102 12.8201L487.102 14.6201L490.702 36.7201L502.302 35.3201V70.3201H524.902V35.3201C524.802 29.2201 522.302 23.5201 518.002 19.3201C513.702 15.1201 507.902 12.8201 501.802 12.8201Z"
                fill="url(#paint8_linear_8042_28185)"
            />
            <path
                d="M331.398 49.4203H335.498L341.398 50.0203L352.598 51.0203L354.598 28.7203L343.398 27.7203C335.998 27.0203 328.798 26.2203 321.798 25.2203L308.898 23.3203V70.4203H331.398V49.4203Z"
                fill="url(#paint9_linear_8042_28185)"
            />
            <path
                d="M309 88.7197H331.4V141.82H309V88.7197Z"
                fill="url(#paint10_linear_8042_28185)"
            />
            <path
                d="M309 160.42H331.4V213.52H309V160.42Z"
                fill="url(#paint11_linear_8042_28185)"
            />
            <path
                d="M399.001 147.72C404.701 140.12 407.502 130.92 407.102 121.52C407.502 112.62 405.001 103.92 399.801 96.7201C395.001 90.7201 387.601 87.3201 379.901 87.5201C372.201 87.4201 364.801 90.8201 359.901 96.8201C354.201 104.32 351.301 113.62 351.801 123.02C351.401 132.22 354.301 141.22 359.901 148.52C364.701 154.12 371.701 157.32 379.101 157.32C386.801 157.12 394.201 153.72 399.001 147.72ZM368.801 122.12C368.801 111.82 372.101 101.32 379.501 101.32C382.901 101.42 386.001 103.52 387.401 106.62C389.401 111.42 390.402 116.52 390.202 121.72C390.202 128.02 389.101 142.72 379.501 142.72C377.301 142.72 375.301 141.82 373.801 140.32C369.901 135.12 368.201 128.62 368.801 122.12Z"
                fill="url(#paint12_linear_8042_28185)"
            />
            <path
                d="M457.099 90.2197H441.499L376.699 204.02H392.299L457.099 90.2197Z"
                fill="url(#paint13_linear_8042_28185)"
            />
            <path
                d="M454.901 136.92C447.101 136.92 439.701 140.42 434.901 146.42C429.201 153.92 426.301 163.22 426.801 172.62C426.401 181.72 429.301 190.72 434.901 198.02C439.701 203.62 446.801 206.82 454.101 206.82C461.402 206.82 469.001 203.42 473.801 197.52C479.401 189.92 482.301 180.72 481.901 171.32C481.801 149.92 471.501 136.92 454.901 136.92ZM454.401 192.92C452.301 192.92 450.201 192.02 448.801 190.52C444.801 185.32 443.001 178.82 443.601 172.32C443.601 162.02 446.901 151.52 454.501 151.52C457.901 151.62 461.001 153.72 462.401 156.82C464.401 161.62 465.402 166.72 465.202 171.92C465.002 177.92 463.701 192.92 454.401 192.92Z"
                fill="url(#paint14_linear_8042_28185)"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_8042_28185"
                x1={50.47}
                y1={10.1397}
                x2={216.02}
                y2={365.17}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.17} stopColor="#01E9BD" />
                <stop offset={0.25} stopColor="#01C1B6" />
                <stop offset={0.34} stopColor="#019AB0" />
                <stop offset={0.44} stopColor="#017AAB" />
                <stop offset={0.54} stopColor="#0161A7" />
                <stop offset={0.64} stopColor="#014FA5" />
                <stop offset={0.75} stopColor="#0145A3" />
                <stop offset={0.87} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_8042_28185"
                x1={188.8}
                y1={0.740306}
                x2={333.92}
                y2={311.95}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.06} stopColor="#01E9BD" />
                <stop offset={0.59} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_8042_28185"
                x1={57.5088}
                y1={-47.7697}
                x2={250.289}
                y2={365.66}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.19} stopColor="#01E9BD" />
                <stop offset={0.35} stopColor="#01A7B2" />
                <stop offset={0.57} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_8042_28185"
                x1={266.72}
                y1={127.51}
                x2={363.17}
                y2={334.35}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.14} stopColor="#01A7B2" />
                <stop offset={0.35} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_8042_28185"
                x1={388.982}
                y1={197.34}
                x2={446.512}
                y2={320.72}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.05} stopColor="#01A7B2" />
                <stop offset={0.13} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_8042_28185"
                x1={473.481}
                y1={161.53}
                x2={533.461}
                y2={290.16}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.05} stopColor="#01A7B2" />
                <stop offset={0.13} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_8042_28185"
                x1={393.602}
                y1={-21.2805}
                x2={448.132}
                y2={95.6595}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0.13} stopColor="#01E9BD" />
                <stop offset={0.15} stopColor="#01E0BB" />
                <stop offset={0.23} stopColor="#01B6B5" />
                <stop offset={0.32} stopColor="#0192AF" />
                <stop offset={0.4} stopColor="#0175AA" />
                <stop offset={0.5} stopColor="#015EA7" />
                <stop offset={0.6} stopColor="#014EA4" />
                <stop offset={0.72} stopColor="#0144A3" />
                <stop offset={0.87} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_8042_28185"
                x1={476.351}
                y1={58.7495}
                x2={548.961}
                y2={214.47}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.05} stopColor="#01A7B2" />
                <stop offset={0.13} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_8042_28185"
                x1={467.362}
                y1={-48.7099}
                x2={538.612}
                y2={104.1}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.05} stopColor="#01A7B2" />
                <stop offset={0.13} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint9_linear_8042_28185"
                x1={303.998}
                y1={-9.95969}
                x2={411.318}
                y2={220.2}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E5BC" />
                <stop offset={0.11} stopColor="#01BAB5" />
                <stop offset={0.23} stopColor="#0195AF" />
                <stop offset={0.34} stopColor="#0176AB" />
                <stop offset={0.46} stopColor="#015FA7" />
                <stop offset={0.59} stopColor="#014EA5" />
                <stop offset={0.74} stopColor="#0145A3" />
                <stop offset={0.92} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint10_linear_8042_28185"
                x1={281.68}
                y1={32.6597}
                x2={350.45}
                y2={180.13}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.12} stopColor="#01CBB8" />
                <stop offset={0.39} stopColor="#0190AF" />
                <stop offset={0.62} stopColor="#0166A8" />
                <stop offset={0.8} stopColor="#014BA4" />
                <stop offset={0.9} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint11_linear_8042_28185"
                x1={290.48}
                y1={123.23}
                x2={377.52}
                y2={309.88}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E6BC" />
                <stop offset={0.06} stopColor="#01BFB6" />
                <stop offset={0.11} stopColor="#019EB1" />
                <stop offset={0.18} stopColor="#0181AC" />
                <stop offset={0.24} stopColor="#016AA9" />
                <stop offset={0.32} stopColor="#0158A6" />
                <stop offset={0.42} stopColor="#014BA4" />
                <stop offset={0.55} stopColor="#0144A3" />
                <stop offset={0.83} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint12_linear_8042_28185"
                x1={352.631}
                y1={64.5401}
                x2={439.001}
                y2={249.75}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E6BC" />
                <stop offset={0.06} stopColor="#01BFB6" />
                <stop offset={0.11} stopColor="#019EB1" />
                <stop offset={0.18} stopColor="#0181AC" />
                <stop offset={0.24} stopColor="#016AA9" />
                <stop offset={0.32} stopColor="#0158A6" />
                <stop offset={0.42} stopColor="#014BA4" />
                <stop offset={0.55} stopColor="#0144A3" />
                <stop offset={0.83} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint13_linear_8042_28185"
                x1={361.299}
                y1={27.8897}
                x2={450.429}
                y2={219.02}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E6BC" />
                <stop offset={0.06} stopColor="#01BFB6" />
                <stop offset={0.11} stopColor="#019EB1" />
                <stop offset={0.18} stopColor="#0181AC" />
                <stop offset={0.24} stopColor="#016AA9" />
                <stop offset={0.32} stopColor="#0158A6" />
                <stop offset={0.42} stopColor="#014BA4" />
                <stop offset={0.55} stopColor="#0144A3" />
                <stop offset={0.83} stopColor="#0242A3" />
            </linearGradient>
            <linearGradient
                id="paint14_linear_8042_28185"
                x1={393.731}
                y1={41.4599}
                x2={490.971}
                y2={249.98}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01E9BD" />
                <stop offset={0.02} stopColor="#01DCBB" />
                <stop offset={0.11} stopColor="#01B3B4" />
                <stop offset={0.2} stopColor="#0190AF" />
                <stop offset={0.3} stopColor="#0173AA" />
                <stop offset={0.4} stopColor="#015DA7" />
                <stop offset={0.52} stopColor="#014EA4" />
                <stop offset={0.65} stopColor="#0144A3" />
                <stop offset={0.83} stopColor="#0242A3" />
            </linearGradient>
            <clipPath id="clip0_8042_28185">
                <rect width={524.91} height={280.62} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default SVGComponent;
